"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCardValidationSchema = void 0;
const Yup = __importStar(require("yup"));
const REQUIRED_FIELD = 'Este campo é obrigatório';
const MUST_BE_GREATER_THAN_ZERO = 'Deve ser maior que zero';
exports.CreateCardValidationSchema = Yup.object({
    brand: Yup
        .string()
        .oneOf(['AMEX', 'VISA', 'ELO', 'MASTERCARD'], 'Deve ser uma bandeira de cartão válida')
        .required(REQUIRED_FIELD),
    bank: Yup.string().required(REQUIRED_FIELD),
    last_four_digits: Yup.string().test({
        test: (value) => {
            const clean = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
            return (clean === null || clean === void 0 ? void 0 : clean.length) === 4;
        },
        message: 'Deve ser um número válido'
    }).required(REQUIRED_FIELD),
});
